import React from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

const Footer = (props) => {

    let buttonEmpresa;
    let buttonCuenta;
    let buttonTarjeta;

    switch (props.data.entidad) {
        case 0:
            buttonEmpresa =
                <div>
                    <div className="col-xs-2">
                    </div>
                    <div className="col-xs-8">
                        <GenericSimpleButton text="Cancelar" buttonClass="btn btn-secondary" onClick={() => props.cerrarModal()} />
                    </div>
                    <div className="col-xs-2">
                        <GenericSimpleButton buttonType="button" text="Siguiente >" buttonClass="btn btn" onClick={() => props.goTo(1)} buttonType="button" />
                    </div>
                </div>
            break;
        case 1:
            buttonCuenta =
                <div>
                    <div className="col-xs-2">
                        <GenericSimpleButton buttonType="button" text="< Anterior" buttonClass="btn btn" onClick={() => props.goTo(0)} buttonType="button" />
                    </div>
                    <div className="col-xs-8">
                        <GenericSimpleButton text="Cancelar" buttonClass="btn btn-secondary" onClick={() => props.cerrarModal()} />
                    </div>
                    <div className="col-xs-2">
                        <GenericSimpleButton buttonType="button" text="Siguiente >" buttonClass="btn btn" onClick={() => props.goTo(2)} buttonType="button" />
                    </div>
                </div>
            break;
        case 2:
            buttonTarjeta =
                <div>
                    <div className="col-xs-2">
                        <GenericSimpleButton buttonType="button" text="< Anterior" buttonClass="btn btn" onClick={() => props.goTo(0)} buttonType="button" />
                    </div>
                    <div className="col-xs-4">
                        <GenericSimpleButton text="Cancelar" buttonClass="btn btn-secondary" onClick={() => props.cerrarModal()} />
                    </div>
                    <div className="col-xs-4">
                        <GenericSimpleButton buttonType="button" text="Denegar" buttonClass="btn btn-cta" onClick={() => props.cambiarEstado(4)} buttonType="button" />
                    </div>
                    <div className="col-xs-2">
                        <GenericSimpleButton buttonType="button" text="Confirmar" buttonClass="btn btn-cta" onClick={() => props.cambiarEstado(3)} buttonType="button" />
                    </div>
                </div>
            break;
    }

    //Empresa Aceptada por Administradora, no se visualiza
    if (props.data.empresa.EmpresaVisaEstadoId == "3") {
        buttonEmpresa = undefined;
        if (props.data.entidad != 2) {

            buttonCuenta = <div>
                <div className="col-xs-10">
                </div>
                <div className="col-xs-2">
                    <GenericSimpleButton buttonType="button" text="Siguiente >" buttonClass="btn btn" onClick={() => props.goTo(2)} buttonType="button" />
                </div>
            </div>
        } else {
            buttonCuenta = undefined;
        }
    }

    //Empresa y Cuenta Aceptada por Administradora, no se visualizan
    if (props.data.cuentas[0].CuentaTarjetaEstadoId == "3") {
        buttonEmpresa = undefined;
        buttonCuenta = undefined;
        buttonTarjeta = <div className="col-xs-12">
            <GenericSimpleButton text="Cancelar" buttonClass="btn btn-secondary" onClick={() => props.cerrarModal()} />
            <GenericSimpleButton buttonType="button" text="Confirmar" buttonClass="btn btn-cta" onClick={() => props.cambiarEstado(3)} buttonType="button" />
            <GenericSimpleButton buttonType="button" text="Denegar" buttonClass="btn btn-cta" onClick={() => props.cambiarEstado(4)} buttonType="button" />
        </div>
    }

    return (
        <div className="row">
            {buttonEmpresa}
            {buttonCuenta}
            {buttonTarjeta}
        </div>
    );
}

export default Footer;